import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from '../../../../styles/icons/default.scss';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: 'currentColor',
    className: null,
};

const LineSmallAlt = ({ color, className }) => (
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width="110px"
        height="5px"
        viewBox="0 0 110 5"
        className={classNames([styles.container, { [className]: className !== null }])}
        xmlSpace="preserve"
    >
        <g>
            <path
                fill={color}
                d="M108.8,1c-0.1-0.1-0.3-0.3-0.3-0.3c-0.2,0.1-0.3,0-0.3-0.2c-0.1-0.5-0.6-0.1-0.8-0.3c-0.3,0.6-0.7,0-1,0
            c-0.2,0.1-0.5,0.3-0.6,0.2c-0.5-0.3-1.1-0.2-1.6-0.1c-0.3,0-0.5,0-0.7-0.4c-0.1,0.3-0.1,0.6-0.2,0.9c-0.6-0.7-1.3-0.7-2-0.4
            c-0.1-0.2-0.3-0.3-0.4-0.4c-0.1,0.1-0.3,0.2-0.4,0.3c-0.1,0.1-0.2,0.1-0.4,0.3c-0.1-0.2-0.1-0.3-0.1-0.3c-0.4,0.1-0.8,0.3-1.1,0.2
            c-0.6-0.2-1.1-0.1-1.6,0c-0.6,0.1-1.2,0.3-1.5-0.2c-0.3,0.1-0.5,0.2-0.7,0.2c-0.2,0-0.4-0.1-0.6-0.2c-0.1,0.3-0.3,0.5-0.7,0.4
            c-0.2-0.1-0.4-0.2-0.7-0.3c-0.3-0.1-0.7-0.1-0.8,0.3c-0.3-0.2-0.5-0.4-0.8-0.5c-0.2,0.2-0.3,0.4-0.5,0.6c-0.1-0.2-0.1-0.4-0.2-0.6
            c-0.3,0-0.6-0.1-0.6,0.4c-0.2,0-0.4,0-0.6,0c-0.2,0-0.3,0.1-0.5,0.1c-0.4-0.2-0.8-0.4-1.2,0c0,0-0.1,0-0.2,0
            c-0.3-0.2-0.6-0.1-0.9-0.1c-0.1,0-0.3-0.2-0.4-0.3c-0.5,0.3-0.5,0.3-1.5,0c0,0.2,0,0.3-0.1,0.5c-0.8-0.2-1.5-0.5-2.3-0.1
            c-0.5-0.3-1.2,0.3-1.6-0.3c-0.3,0.1-0.5,0.2-0.7,0.3c-0.1-0.2-0.3-0.3-0.4-0.5c-0.1,0.2-0.2,0.4-0.2,0.4c-0.4-0.1-0.8-0.2-1.1-0.1
            c-0.4,0.1-0.7,0.1-1-0.2c-0.1-0.1-0.2-0.1-0.4-0.2c0,0.2-0.1,0.4-0.1,0.6c-0.4-0.1-0.7-0.3-1.1-0.4c0,0-0.1,0-0.1,0.1
            c-0.2,0.2-0.4,0.3-0.6,0.5c0-0.1-0.1-0.2-0.2-0.4c-0.3,0.1-0.5,0.2-0.7,0.2c-0.2,0-0.3-0.2-0.4-0.3c-0.3,0.1-0.5,0.3-0.7,0.3
            c-0.9-0.1-1.9,0-2.8-0.2c-0.1,0-0.3-0.1-0.4,0c-0.6,0.6-1.3-0.1-1.9,0.1c-0.5-0.6-0.7-0.1-1,0.3c-0.4-0.5-0.7-0.7-1.2-0.2
            c-0.1,0.1-0.2,0.1-0.3,0.1c-0.5-0.2-0.9,0.1-1.2,0.4c-0.1-0.2-0.2-0.4-0.2-0.4c-0.6,0.2-1.1-0.1-1.7-0.1c-0.7,0-1.4,0.4-2.1,0.1
            c-0.4,0.3-0.8,0-1.2-0.1c-0.1,0-0.4-0.1-0.4-0.1c-0.4,0.6-0.7,0.1-1,0C57.1,0.7,57,0.7,56.9,0c-0.2,0.3-0.3,0.5-0.5,0.8
            c-0.4-0.6-1.1,0.1-1.5-0.4c-0.1,0.2-0.2,0.4-0.3,0.7c-0.3-0.3-0.6-0.5-0.9-0.8c-0.5,0.5-1.1,0-1.7,0.1c0,0.1,0,0.2,0,0.3
            c-0.5,0.1-0.9,0-1.2-0.5c-0.3,0.1-0.5,0.7-0.9,0.4c-0.5-0.4-0.6,0.1-0.8,0.4c-0.3-0.3-0.5-0.9-0.9-0.2c-0.1-0.2-0.3-0.4-0.4-0.6
            c-0.3,0.2-0.5,0.3-0.7,0.4C47.1,0.4,47,0.3,47,0.2c-0.3,0.1-0.6,0.3-0.8,0.4c-0.1-0.1-0.2-0.3-0.3-0.4c-0.2,0.2-0.3,0.3-0.5,0.6
            c-0.1-0.2-0.2-0.4-0.3-0.6c-0.5,0.5-1,0.6-1.4,0.4c-0.7-0.3-1.3-0.2-1.8,0c-0.3-0.1-0.6-0.1-0.8-0.2c-0.3-0.2-0.4,0.4-0.7,0.2
            c-0.1-0.2-0.3-0.3-0.4-0.5c-0.3,0.2-0.5,0.4-0.7,0.6c-0.3-0.2-0.6-0.3-1-0.5c-0.1,0.2-0.2,0.3-0.3,0.4c-0.2,0-0.3-0.1-0.5-0.1
            c-0.2,0-0.4,0-0.6-0.1c-0.4-0.1-0.8-0.4-1,0.2c-0.4-0.3-1,0.1-1.4-0.3c-0.2-0.2-0.4-0.2-0.4,0.1c-0.1,0.3-0.2,0.2-0.4,0.3
            c-0.1,0-0.2,0.2-0.3,0.3C33.1,1,33,0.9,33,0.8c-0.1-0.1-0.2-0.2-0.2-0.2c-0.1,0.1-0.3,0.2-0.4,0.2c-0.3,0-0.6-0.2-0.8-0.2
            c-0.5-0.1-0.7,0.1-0.9,0.7c0,0-0.1,0.1-0.2,0.1c0-0.3,0-0.5,0-0.9c-0.3,0.1-0.4,0.1-0.6,0.2c-0.1,0-0.3,0.1-0.4,0.1
            c-0.1-0.1-0.2-0.3-0.3-0.6c-0.3,0.2-0.5,0.4-0.7,0.6c-0.2,0-0.5-0.1-0.8-0.2c-0.7-0.2-0.7-0.3-1,0.3c-0.2-0.4-0.7-0.5-1-0.3
            c-0.3,0.1-0.5,0.1-0.8,0c-0.4,0-0.7-0.1-1.1,0.1c-0.2,0.1-0.4,0-0.6-0.1c-0.4-0.2-0.5-0.1-0.6,0.3c-0.7,0.3-1.3-0.4-2-0.5
            c0.1,0.2,0.1,0.3,0.2,0.5c-0.6,0.2-0.8-0.1-1-0.6c-0.3,0.3-0.5,0.3-0.9,0.2c-0.1,0-0.2,0-0.2,0c-0.3,0.4-0.5,0.2-0.8,0
            c-0.1-0.1-0.5-0.1-0.5,0c-0.1,0.4-0.5,0.2-0.5,0.2c-0.3,0.4-0.5-0.2-0.8-0.1c-0.3,0.1-0.6,0.3-0.9,0c-0.2-0.2-0.7,0-1,0
            c-0.4,0.1-0.7-0.1-1.1-0.4c-0.1,0.2-0.2,0.3-0.3,0.4c-0.3-0.2-0.4-0.4-0.7-0.5c-0.3,0.7-0.7,0.6-1.2,0.3c-0.2-0.1-0.4-0.1-0.7-0.2
            c0.1,0.2,0.1,0.4,0.2,0.6c-0.3-0.1-0.7,0-0.8-0.2c-0.4-0.5-0.6-0.3-1,0C8,0.9,7.5,0.9,7,0.9c-0.2,0-0.4-0.3-0.6-0.5
            C6,0.8,5.7,1,5.4,0.8C4.9,0.7,4,0.6,3.6,0.7C3.3,0.9,3,0.8,2.9,0.4c0-0.1-0.1-0.1-0.2-0.2c0,0.2,0,0.3,0,0.4
            C2.1,0.6,1.6,0.5,1.2,0.4C0.9,0.7,0.7,0.9,0.5,1C0.3,1.3,0,1.5,0,1.7l0.7,0.4c0.4,0.1,1,0.1,1.6,0.2c0-0.2,0-0.3,0-0.5
            C2.3,2,2.4,2,2.4,2.1c0.1,0.4,0.4,0.5,0.7,0.4c0.2-0.1,0.5-0.1,0.8-0.1c0,0,0.1,0,0.2,0c0,0,0,0,0,0c0.4,0,0.7,0.1,1,0.2
            c0.3,0.1,0.6,0,1-0.5c0.2,0.2,0.4,0.5,0.7,0.5c0.5,0,1,0,1.4-0.2c0.4-0.3,0.7-0.5,1.1,0C9.3,2.6,9.6,2.5,10,2.6
            C9.9,2.4,9.9,2.2,9.8,2c0.3,0.1,0.5,0.1,0.7,0.2c0.5,0.2,0.9,0.3,1.2-0.4c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0c0-0.1,0.1-0.1,0.2-0.2
            C12,1.9,12,2,12,2.1c0,0,0,0,0,0c0.1,0.1,0.3,0.2,0.4,0.3c0.1-0.1,0.2-0.3,0.3-0.5c0.4,0.2,0.7,0.5,1.1,0.4c0.3-0.1,0.8-0.2,1,0
            c0.4,0.3,0.7,0.1,0.9,0.1c0.3-0.1,0.5,0.5,0.8,0.1c0.1-0.1,0.5,0.2,0.6-0.3c0,0,0.1,0,0.2,0c0-0.1-0.1-0.1-0.1-0.2
            c0-0.1,0.1-0.1,0.1-0.2c0,0.1,0.1,0.1,0.1,0.2c0,0,0,0.1-0.1,0.2c0.1,0,0.2,0,0.3,0.1c0.3,0.2,0.6,0.4,0.9,0c0,0,0.1,0,0.2,0
            c0.5,0.1,0.6,0,1-0.2c0.2,0.5,0.5,0.8,1.1,0.6c-0.1-0.2-0.1-0.3-0.2-0.5c0.8,0.1,1.3,0.8,2.1,0.5C22.8,2.1,23,2,23.3,2.2
            c0.2,0.1,0.4,0.2,0.7,0.1c0.4-0.2,0.7-0.1,1.1-0.1c0.3,0,0.5,0.1,0.9,0c0.3-0.2,0.8-0.1,1,0.4C27.4,2,27.4,2,28.1,2.3
            c0.3,0.1,0.6,0.1,0.8,0.2c0.3-0.2,0.5-0.4,0.8-0.7c0.1,0.3,0.2,0.5,0.3,0.6c0.1,0.1,0.3,0,0.4-0.1c0.2,0,0.4-0.1,0.6-0.2
            c0,0.3,0,0.6,0,0.9c0.1,0,0.2-0.1,0.2-0.1c0.2-0.6,0.4-0.8,0.9-0.7c0.3,0,0.6,0.2,0.9,0.2c0.1,0,0.3-0.1,0.4-0.2
            c0,0,0.1,0.1,0.2,0.2c0.1,0.1,0.2,0.2,0.3,0.2c0.1-0.1,0.2-0.3,0.3-0.3c0.2,0,0.4,0,0.4-0.3c0.1-0.3,0.3-0.3,0.5-0.1
            c0.4,0.4,1,0,1.4,0.3c0.3-0.6,0.7-0.3,1.1-0.2c0.2,0,0.4,0,0.6,0.1c0.2,0,0.3,0,0.5,0.1C38.7,2.3,38.8,2.1,39,2
            c0.3,0.2,0.7,0.3,1,0.5c0.2-0.2,0.5-0.4,0.7-0.6C40.8,2,41,2.2,41.1,2.4c0.3,0.2,0.4-0.4,0.8-0.2c0.2,0.1,0.5,0.1,0.8,0.2
            c0.6-0.2,1.2-0.4,1.9-0.1c0.5,0.2,1,0.1,1.5-0.4c0.1,0.2,0.2,0.4,0.3,0.6c0.2-0.3,0.4-0.4,0.6-0.6c0.1,0.2,0.2,0.3,0.3,0.5
            c0.3-0.2,0.6-0.3,0.9-0.5c0,0.1,0.1,0.2,0.2,0.3C48.5,2.1,48.7,2,49,1.9c0.1,0.2,0.2,0.4,0.4,0.6c0,0,0,0,0,0c-0.1-0.2,0-0.4,0-0.7
            c0.1,0.2,0.1,0.3,0.2,0.5c0.3-0.2,0.5,0.3,0.7,0.5c0.2-0.3,0.3-0.8,0.8-0.4c0.4,0.3,0.6-0.3,0.9-0.4c0.3,0.5,0.7,0.6,1.2,0.5
            c0-0.1,0-0.2,0-0.4c0.6-0.2,1.2,0.4,1.7-0.1c0.3,0.3,0.6,0.5,1,0.8c0.1-0.2,0.2-0.4,0.3-0.7c0.5,0.6,1.1-0.1,1.5,0.5
            c0.2-0.3,0.3-0.5,0.5-0.8c0.1,0.7,0.2,0.8,0.8,0.4c0.3,0.2,0.7,0.7,1.1,0c0-0.1,0.3,0,0.4,0.1c0.3,0.1,0.6,0.3,1,0.2
            c0.1,0,0.1-0.1,0.2-0.1c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0.8,0.3,1.5-0.1,2.2-0.1c0.6,0,1.1,0.2,1.7,0.1c0,0,0.1,0.2,0.2,0.4
            c0.3-0.4,0.7-0.7,1.2-0.5c0.1,0,0.2,0,0.3-0.1c0.5-0.4,0.9-0.2,1.2,0.3c0.3-0.3,0.6-0.9,1.1-0.3C70.6,2,71.3,2.6,71.9,2
            C72,2,72.1,2,72.3,2c1,0.3,2,0.1,3,0.2c0.2,0,0.5-0.2,0.8-0.3c0.1,0.1,0.2,0.3,0.4,0.3c0.2,0,0.4-0.1,0.7-0.2
            c0.1,0.1,0.2,0.3,0.2,0.4c0.2-0.2,0.4-0.3,0.6-0.5C77.9,2,78,2,78,2c0.4,0.1,0.7,0.3,1.1,0.4c0-0.3,0.1-0.4,0.1-0.6
            c0.1,0.1,0.3,0.1,0.4,0.2c0.3,0.3,0.7,0.2,1.1,0.2C81,2,81.4,2.1,81.8,2.2c0,0,0.1-0.2,0.2-0.4c0.2,0.2,0.3,0.3,0.4,0.5
            c0.1,0,0.2-0.1,0.3-0.1c0-0.1-0.1-0.1-0.1-0.2c0.2,0,0.3,0,0.4,0.1c0.1,0,0.1,0,0.2-0.1c0,0,0,0.1,0.1,0.1c-0.1-0.3,0-0.4,0.3-0.6
            c0,0.2,0,0.4,0.1,0.6c-0.2,0-0.3,0-0.4,0c0.4,0.4,1.1-0.1,1.6,0.2c0.8-0.4,1.6-0.1,2.3,0.1c0-0.2,0-0.3,0.1-0.5
            c1.1,0.3,1.1,0.3,1.6,0C89,2,89.2,2.1,89.3,2.2C89.6,2.2,90,2,90.3,2.3c0,0,0.1,0,0.2,0c0.4-0.4,0.8-0.1,1.2,0
            c0.1,0.1,0.3,0,0.5-0.1c0.2,0,0.4,0,0.7,0c0-0.5,0.3-0.4,0.6-0.4c0.1,0.2,0.1,0.3,0.2,0.6c0.2-0.2,0.3-0.4,0.5-0.6
            c0.3,0.2,0.5,0.4,0.8,0.6C95,1.9,95.4,1.9,95.7,2C96,2,96.2,2.2,96.5,2.3c0.4,0.1,0.6,0,0.7-0.4c0.2,0.1,0.4,0.2,0.7,0.2
            C98,2.1,98.2,2,98.5,2c0.4,0.6,1,0.3,1.6,0.2c0.6-0.1,1.1-0.2,1.7,0c0.3,0.1,0.7-0.1,1.1-0.2c0,0,0.1,0.2,0.1,0.4
            c0.2-0.1,0.3-0.2,0.5-0.3c0.1-0.1,0.2-0.2,0.4-0.3c0.1,0.1,0.2,0.3,0.4,0.4c0.7-0.4,1.4-0.4,2.1,0.4c0.1-0.4,0.1-0.6,0.2-1
            c0.2,0.4,0.4,0.5,0.8,0.4c0.5-0.1,1.1-0.2,1.6,0.1c0.2,0.1,0.4-0.1,0.7-0.2c0.1,0,0.3,0.1,0.4,0.1c0-0.1,0-0.2,0-0.2
            c0-0.4-0.2-0.7-0.5-0.8c-0.1-0.1-0.2-0.2-0.4-0.2C109,0.8,108.9,1.1,108.8,1z M4.4,1.9C4,2,3.9,1.9,4,1.4C4.2,1.6,4.3,1.8,4.4,1.9z
             M6.4,1.2c-0.1,0-0.1-0.1-0.2-0.1C6.3,1,6.3,1,6.3,0.9C6.4,1,6.5,1,6.5,1.1C6.5,1.1,6.4,1.2,6.4,1.2z M9,1.9c0,0-0.1,0-0.1,0
            c0-0.1,0-0.2,0-0.3c0.1,0,0.1,0,0.2,0C9,1.6,9,1.7,9,1.9z M10.9,1.7c-0.1-0.4-0.1-0.4,0.3-0.4C11.1,1.4,11.1,1.5,10.9,1.7z
             M18.4,2.2c0,0.1-0.1,0.1-0.1,0.1c0-0.1-0.1-0.1-0.1-0.2c0-0.1,0.1-0.1,0.1-0.2C18.4,2.1,18.4,2.2,18.4,2.2z M19.4,1.2
            c-0.1,0-0.1-0.1-0.2-0.2c0.1,0,0.1-0.1,0.2-0.2c0.1,0.1,0.1,0.2,0.2,0.2C19.5,1.1,19.4,1.2,19.4,1.2z M22.9,1.9
            C22.8,2,22.8,2,22.7,2.1c0-0.1-0.1-0.1-0.1-0.2c0-0.1,0.1-0.1,0.1-0.2C22.7,1.8,22.8,1.8,22.9,1.9z M49.4,1.7
            c-0.3,0.1-0.4,0-0.3-0.5C49.3,1.5,49.4,1.6,49.4,1.7z M63.1,1.5c0.1-0.3,0.3-0.5,0.6-0.3C63.6,1.4,63.5,1.7,63.1,1.5z"
            />
            <path fill={color} d="M50.6,3.5c-0.1-0.1-0.2-0.2-0.3-0.5C50.2,3.5,50.3,3.6,50.6,3.5z" />
            <path fill={color} d="M64.8,3.2c0.4,0.2,0.5-0.1,0.6-0.4C65.1,2.7,64.9,2.9,64.8,3.2z" />
            <path
                fill={color}
                d="M11.7,3.9c0.1,0,0.2,0,0.2-0.1c0-0.1,0-0.2,0-0.4c-0.1,0.1-0.2,0.2-0.2,0.2C11.6,3.7,11.7,3.8,11.7,3.9z"
            />
            <path fill={color} d="M10.8,3.4C10.9,3.3,11,3.1,11.1,3C10.6,3,10.6,3,10.8,3.4z" />
            <path
                fill={color}
                d="M8.6,3.6c0,0,0.1,0,0.1,0c0-0.1,0-0.2,0-0.3c-0.1,0-0.1,0-0.2,0C8.6,3.4,8.6,3.5,8.6,3.6z"
            />
            <path
                fill={color}
                d="M5.9,2.8C5.9,2.8,6,2.9,6,2.9c0.1,0,0.1-0.1,0.2-0.1C6.2,2.7,6.1,2.7,6,2.6C5.9,2.7,5.9,2.7,5.9,2.8z"
            />
            <path
                fill={color}
                d="M19.3,2.7c0.1,0.1,0.1,0.1,0.2,0.2c0,0,0.1-0.1,0.2-0.1c-0.1-0.1-0.1-0.1-0.2-0.2C19.4,2.6,19.3,2.6,19.3,2.7z
            "
            />
            <path
                fill={color}
                d="M22.8,3.7c0,0.1,0.1,0.1,0.1,0.2c0-0.1,0.1-0.1,0.2-0.2C23,3.6,23,3.5,22.9,3.5C22.9,3.5,22.8,3.6,22.8,3.7z"
            />
            <path
                fill={color}
                d="M26.7,4.8c0,0.1,0.1,0.1,0.2,0.1C26.9,5,27,4.9,27,4.8c0-0.1-0.1-0.1-0.2-0.4C26.8,4.7,26.7,4.8,26.7,4.8z"
            />
            <path
                fill={color}
                d="M18.3,4.1c0.1,0,0.1-0.1,0.2-0.1c0-0.1,0-0.1-0.1-0.3c-0.1,0.1-0.2,0.2-0.2,0.2C18.2,4,18.3,4,18.3,4.1z"
            />
            <path
                fill={color}
                d="M17.5,3.7c0-0.1-0.1-0.1-0.1-0.2c0,0.1-0.1,0.1-0.1,0.2c0,0.1,0.1,0.1,0.1,0.2C17.4,3.8,17.5,3.7,17.5,3.7z"
            />
            <path
                fill={color}
                d="M19.3,5c0.1,0,0.1-0.1,0.2-0.1c-0.1,0-0.1-0.1-0.2-0.2c-0.1,0.1-0.1,0.1-0.1,0.2C19.1,4.9,19.2,5,19.3,5z"
            />
        </g>
    </svg>
);

LineSmallAlt.propTypes = propTypes;
LineSmallAlt.defaultProps = defaultProps;

export default LineSmallAlt;
